module.exports = __webpack_public_path__ + "img/bu-logo-smaller-2.16c58e55.png";